import { AppSettings } from '../constants';
import Jwt from '../helper/interceptors';
import removeDiacritics from '../helper/remove-diacritics';
import { ObjToParam, MapResponse } from '../helper/helper-api';
import { v4 as uuidv4 } from 'uuid';
import S3 from 'aws-sdk/clients/s3';
import { config, Credentials } from 'aws-sdk/lib/core';

import PubSub from 'services/pubsub-service';
import * as PubSubActionType from 'services/constants';

export const create = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: 'Key', value: params.requestId }]
  })
    .post('/api/work-orders', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const sendBulkMail = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .post(params.type === 'system' ? '/api/bulk-mail' : '/api/sub-of-projects/bulk-mail', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const createScheduleWorkOrder = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .post('/api/work-orders/schedule', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const uploadFiles = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, 'multipart/form-data')
    .post('/api/work-orders/uploadfiles', params, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getWorkOrdersByRFSID = (ID, params) => {
  return Jwt(AppSettings.GLOBAL_API_URL)
    .get(`/apiv1/request-for-services/${ID}/work-orders?${ObjToParam(params)}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getWorkOrderDetail = params => {
  return Jwt(AppSettings.GLOBAL_API_URL, true, {
    headers: [{ key: 'Key', value: params.woRefNo }]
  })
    .get(
      `/apiv1/request-for-services/${params.rfsRefNo}/work-orders/${params.woRefNo}`
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const updateWorkOrder = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: 'Key', value: params.refNo }]
  })
    .put(`/api/work-orders/${params.refNo}`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const openAwaitingWorkOrder = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: 'Key', value: params.refNo }]
  })
    .put(`/api/work-orders/${params.refNo}/open`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

// BULKWOSend
export const BulkUpdateMultipleWO = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, {
    headers: {'Content-Type': 'application/json'}
  })
    .put(`/api/work-orders/BulkUpdateMultipleWO`, params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const resolveWorkOrder = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: 'Key', value: params.refNo }]
  })
    .put(`/api/work-orders/${params.refNo}/resolve`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const signoffWorkOrder = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: 'Key', value: params.refNo }]
  })
    .put(`/api/work-orders/${params.refNo}/close`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const declineWorkOrder = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: 'Key', value: params.refNo }]
  })
    .put(`/api/work-orders/${params.refNo}/decline/${params.projectId}`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const pendWorkOrder = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: 'Key', value: params.refNo }]
  })
    .put(`/api/work-orders/${params.refNo}/pend`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const openPendingWorkOrder = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: 'Key', value: params.refNo }]
  })
    .put(`/api/work-orders/${params.refNo}/open-pending`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const pendingOpenWorkOrder = params => {
  const endpoint =
    params.type === 'workOrder'
      ? `/api/work-orders/${params.refNo}/hold`
      : `/api/punch-lists/${params.rfsId}/punch-items/${params.refNo}/hold`;
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: 'Key', value: params.refNo }]
  })
    .put(endpoint, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const reOpenWorkOrder = params => {
  let openClose;
  if (params.isFromResolved) {
    openClose = 'reopen-resolve';
  } else {
    openClose = 'reopen-close';
  }
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: 'Key', value: params.refNo }]
  })
    .put(`/api/work-orders/${params.refNo}/${openClose}`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const reviewReOpenWorkOrder = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: 'Key', value: params.refNo }]
  })
    .put(`/api/work-orders/${params.refNo}/review-reopen`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const submitDeclinedWorkOrder = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: 'Key', value: params.refNo }]
  })
    .put(`/api/work-orders/${params.refNo}/review-decline`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const editRequestedReOpenWorkOrder = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .put(`/api/work-orders/${params.refNo}/requested-reopen`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getWorkOrderComments = params => {
  return Jwt(AppSettings.GLOBAL_API_URL, false, {
    headers: [{ key: 'Key', value: params.workOrderId }]
  })
    .get(
      `/apiv1/request-for-services/${params.rfsId}/work-orders/${
        params.workOrderId
      }/comments?${ObjToParam(params.data)}`
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getWorkOrderPrivateNotes = params => {
  return Jwt(AppSettings.GLOBAL_API_URL, false, {
    headers: [{ key: 'Key', value: params.workOrderId }]
  })
    .get(
      `/apiv1/request-for-services/${params.rfsId}/work-orders/${
        params.workOrderId
      }/comments?${ObjToParam(params.data)}`
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const addWorkOrderComment = params => {
  return Jwt(AppSettings.GLOBAL_API_URL, false, {
    headers: [{ key: 'Key', value: params.workOrderId }]
  })
    .post(
      `/apiv1/request-for-services/${params.rfsId}/work-orders/${params.workOrderId}/comments`,
      params.data
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};
export const deleteWorkOrderPrivateNote = params => {
  return Jwt(AppSettings.GLOBAL_API_URL, false, {
    headers: [{ key: 'Key', value: params.workOrderId }]
  })
    .delete(
      `/apiv1/request-for-services/${params.rfsId}/work-orders/${params.workOrderId}/comments/${[params.id]}`
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const updateCaptionAttachmentWorkOrder = params => {
  return Jwt(AppSettings.GLOBAL_API_URL, false)
    .put(
      `/apiv1/request-for-services/work-orders/${params.refNo}/attachments/${params.id}`,
      params.data
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const subcontractorWorkOrderAwsCredential = params => {
  return Jwt(null, true, {
    headers: [{ key: params.headers.key, value: params.headers.value }]
  })
    .post(params.endpoint, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const workOrderAwsCredential = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .post('/api/aws/s3/credentials', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const dowloadFileFromS3 = params => {
  config.credentials = new Credentials({
    accessKeyId: params.config.accessKeyId,
    secretAccessKey: params.config.secretAccessKey,
    sessionToken: params.config.sessionToken
  });

  const bucketInstance = new S3({ region: params.config.region });
  bucketInstance.getObject(
    {
      Bucket: params.config.bucket,
      Key: params.key
    },
    (err, res) => {
      if (res) {
        var blob = new Blob([res.Body], { type: res.ContentType });
        var filename = params.fileName;
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
          window.navigator.msSaveBlob(blob, filename);
        } else {
          var URL = window.URL || window.webkitURL;
          var downloadUrl = URL.createObjectURL(blob);

          if (filename) {
            // use HTML5 a[download] attribute to specify filename
            var a = document.createElement('a');
            // safari doesn't support this yet
            if (typeof a.download === 'undefined') {
              window.location = downloadUrl;
            } else {
              a.href = downloadUrl;
              a.download = filename;
              document.body.appendChild(a);
              a.click();
            }
          } else {
            window.location = downloadUrl;
          }

          setTimeout(() => {
            URL.revokeObjectURL(downloadUrl);
          }, 100); // cleanup
        }
      } else {
        if (process.env.NODE_ENV === 'development') {
          console.log('Check if you have sufficient permissions : ' + err);
        }
      }
    }
  );
};

export const uploadToServer = params => {
  return Jwt(AppSettings.GLOBAL_API_URL, false, {
    headers: [{ key: 'Key', value: params.refNo }]
  })
    .post(
      `/apiv1/request-for-services/work-orders/${params.refNo}/attachments`,
      params.data
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const uploadWorkOrderFile = (params, callback) => {
  config.credentials = new Credentials({
    accessKeyId: params.config.accessKeyId,
    secretAccessKey: params.config.secretAccessKey,
    sessionToken: params.config.sessionToken
  });

  PubSub.publish(PubSubActionType.LOADING_INDICATOR, {
    isHideIndicator: false
  });
  const fileName = removeDiacritics(params.file.name);
  const enFileName = uuidv4() + '.' + fileName.split('.').pop();
  const s3 = new S3({ region: params.config.region });

  const payload = {
    ACL: 'public-read',
    Body: params.file,
    Bucket: params.config.bucket,
    ContentType: params.file.type,
    ContentDisposition: 'inline; filename="' + fileName + '"',
    Key: `${params.config.path}/${enFileName}`
  };
  let upload = s3.upload(payload);
  let isDelete = false;
  upload.send((error, data) => {
    if (data) {
      /**
       * callback delete file after upload file success
       */
      if (isDelete) {
        const bucketInstance = new S3({ region: params.config.region });
        bucketInstance.deleteObject(
          {
            Bucket: params.config.bucket,
            Key: `${params.config.path}/${enFileName}`
          },
          (err, res) => {
            if (res) {
              if (process.env.NODE_ENV === 'development') {
                console.log('File deleted successfully');
              }
            } else {
              if (process.env.NODE_ENV === 'development') {
                console.log(
                  'Check if you have sufficient permissions : ' + err
                );
              }
            }
          }
        );
      } else {
        callback(true, { data, refNo: params.refNo });
      }
    } else {
      /**
       * callback when upload file success
       */
      callback(false, { data, refNo: params.refNo });
    }

    PubSub.publish(PubSubActionType.LOADING_INDICATOR, {
      isHideIndicator: true
    });
  });
  /**
   * callback when user cancel uploading file
   */
  const cancelUpload = () => {
    setTimeout(upload.abort.bind(upload), 100);
  };
  const deleteFile = () => {
    isDelete = true;
  };
  if (params.file.size > 1024 * 1024 * 5) {
    callback('pending', {
      cancelUpload,
      uploadId: params.file.uploadId,
      fileName
    });
  } else {
    callback('delete', {
      deleteFile,
      uploadId: params.file.uploadId,
      fileName
    });
  }
};

export const uploadSignatureHomeowner = (params, callback) => {
  config.credentials = new Credentials({
    accessKeyId: params.config.accessKeyId,
    secretAccessKey: params.config.secretAccessKey,
    sessionToken: params.config.sessionToken
  });

  const fileName = uuidv4() + '.png';
  const s3 = new S3({ region: params.config.region });
  const buf = new Buffer(params.data.replace(/^data:image\/\w+;base64,/, ''),'base64');
  const payload = {
    ACL: 'public-read',
    Body: buf,
    Bucket: params.config.bucket,
    ContentType: 'image/png',
    ContentEncoding: 'base64',
    // ContentDisposition: 'inline; filename="' + fileName + '"',
    Key: `${params.config.path}/${fileName}`
  };

  let upload = s3.upload(payload);
  upload.send((error, data) => {
    if (data) {
      callback(true, {data, refNo: params.refNo });
    }
    else {
      callback(false, {data, refNo: params.refNo });
    }
  });
};

export const searchSubcontractorWorkOrders = params => {
  return Jwt(AppSettings.GLOBAL_API_URL, true)
    .get(
      `/apiv1/request-for-services/work-orders/subcontractors?${ObjToParam(
        params
      )}`
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const searchWorkOrderList = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .get(`/api/reports/work-orders/search?${ObjToParam(params)}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const resolveSubcontractorWorkOrder = params => {
  return Jwt(null, true, {
    headers: [{ key: params.headers.key, value: params.headers.value }]
  })
    .put(params.endpoint, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const pendingSubcontractorOpenWorkOrder = params => {
  return Jwt(null, true, {
    headers: [{ key: params.headers.key, value: params.headers.value }]
  })
    .put(params.endpoint, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const printPreviewWorkOrder = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .get(`/api/work-orders/print-preview/${params.refNo}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const resendNotice = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .put(`/api/work-orders/${params.refNo}/notify`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const signOffuploadAttachmentToS3 = (params, callback) => {
  config.credentials = new Credentials({
    accessKeyId: params.config.accessKeyId,
    secretAccessKey: params.config.secretAccessKey,
    sessionToken: params.config.sessionToken
  });

  const fileName = removeDiacritics(params.file.name);
  const enFileName = uuidv4() + '.' + fileName.split('.').pop();
  const s3 = new S3({ region: params.config.region });

  const payload = {
    ACL: 'public-read',
    Body: params.file,
    Bucket: params.config.bucket,
    ContentType: params.file.type,
    ContentDisposition: 'inline; filename="' + fileName + '"',
    Key: `${params.config.path}/${enFileName}`
  };
  let upload = s3.upload(payload);

  upload.send((error, data) => {
    if (data) {
      if (process.env.NODE_ENV === 'development') {
        console.log('data', data);
      }
      callback(data);
    } else {
      if (process.env.NODE_ENV === 'development') {
        console.log('error', error);
      }
    }
  });
};

export const signOffUploadAttachmentToServer = params => {
  return Jwt(AppSettings.GLOBAL_API_URL, false)
    .post(
      `/apiv1/request-for-services/work-orders/${params.refNo}/attachments/sign-off`,
      params.data
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const createBackCharge = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: 'Key', value: params.rfsId }]
  })
    .post('api/back-charges', params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const editBackCharge = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: 'Key', value: params.refNo }]
  })
    .put(`api/back-charges/${params.refNo}`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getBackChargeDetail = params => {
  return Jwt(AppSettings.GLOBAL_API_URL, true, {
    headers: [{ key: 'Key', value: params.refNo }]
  })
    .get(`/apiv1/back-charges/${params.refNo}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getBackChargeListOfPurchaseOrder = params => {
  return Jwt(AppSettings.GLOBAL_API_URL, true, {
    headers: [{ key: 'Key', value: params.refNo }]
  })
    .get(`/apiv1/back-charges/search?${ObjToParam(params.data)}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getAllUsersEmail = params => {
  return Jwt(AppSettings.GLOBAL_API_URL, true, {
    // headers: [{ key: 'Key', value: params.refNo }]
  })
    .get(`/apiv1/request-for-services/GetAllUsersEmailIdforAutcomplete`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getWorkOrderHistory = params => {
  return Jwt(AppSettings.GLOBAL_API_URL, true, {
    headers: [{ key: 'Key', value: params.refNo }]
  })
    .get(`/apiv1/histories/work-orders/${params.refNo}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

// SUBCONTRACTOR

export const printPreviewSubcontractorWorkOrder = params => {
  return Jwt(null, true, {
    headers: [{ key: params.headers.key, value: params.headers.value }]
  })
    .get(params.endpoint, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getGlobalWorkOrderDetail = params => {
  return Jwt(AppSettings.GLOBAL_API_URL, true, {
    headers: [{ key: 'Key', value: params.WOID }]
  })
    .get(
      `/apiv1/request-for-services/${params.RFSID}/work-orders/${params.WOID}`
    )
    .then(response => {
      console.log('WO Detail API Response', response)
      return MapResponse(response);
    })
    .catch(error => {
      console.log('WO Detail API Catch Response', error)
      var response = error.response;
      return MapResponse(response);
    });
};

// HOMEOWNERS

export const AddHomeownerWorkOrder = params => {
  return Jwt(null, false, {
    headers: [{ key: params.headers.key, value: params.headers.value }]
  })
    .post(
      `${params.endpoint}/api/portal-homeowners/${params.rfsRefNo}/work-orders`,
      params.data
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const EditHomeownerWorkOrder = params => {
  return Jwt(null, true, {
    headers: [{ key: params.headers.key, value: params.headers.value }]
  })
    .put(
      `${params.endpoint}/api/portal-homeowners/work-orders/${params.refNo}`,
      params.data
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getHomeownerWorkOrderAwsCredential = params => {
  return Jwt(null, false, {
    headers: [{ key: params.headers.key, value: params.headers.value }]
  })
    .post(`${params.endpoint}/api/aws/s3/credentials`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const reOpenHomeownerWorkOrder = params => {
  return Jwt(null, true, {
    headers: [{ key: params.headers.key, value: params.headers.value }]
  })
    .put(
      `${params.builderHost}/api/portal-homeowners/${params.refNo}/reopen-resolve`,
      params.data
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const signOffHomeownerWorkOrder = params => {
  return Jwt(null, true, {
    headers: [{ key: params.headers.key, value: params.headers.value }]
  })
    .put(
      `${params.builderHost}/api/portal-homeowners/work-orders/${params.refNo}/close`,
      params.data
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const homeownerSetupAWS = params => {
  return Jwt(null, true, {
    headers: [{ key: params.headers.key, value: params.headers.value }]
  })
    .post(`${params.builderHost}/api/aws/s3/credentials`, params.param)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const submitDeclinedHomeownerWorkOrder = params => {
  return Jwt(null, true, {
    headers: [{ key: params.headers.key, value: params.headers.value }]
  })
    .put(
      `${params.builderHost}/api/portal-homeowners/${params.param.refNo}/review-decline`,
      params.param.data
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const printPreviewHomeownerWorkOrder = params => {
  return Jwt(null, true, {
    headers: [{ key: params.headers.key, value: params.headers.value }]
  })
    .get(
      `${params.endpoint}/api/work-orders/print-preview/${params.refNo}`,
      params.data
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const exportWorkOrderList = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, { responseType: 'blob' })
    .get(`/api/reports/export/work-orders?${ObjToParam(params)}`)
    .then(response => {
      return MapResponse(response, true);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const reassignMultipleWorkOrder = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .put('/api/work-orders/reassign-internal-users', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

//SUBCONTRACTOR

export const editSubcontractorWorkOrder = params => {
  return Jwt(null, true, {
    headers: [{ key: params.headers.key, value: params.headers.value }]
  })
    .put(
      `${params.endpoint}`,
      params.data
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

//check homeownerSignature true/false

export const checkHomeownerSignatureWO = params => {
  return Jwt(AppSettings.GLOBAL_API_URL, false, {
    headers: [{ key: 'Key', value: params.refNo }]
  })
    .get(
      `/apiv1/work-orders/CheckExistHomeOwnerSignature/${params.refNo}`
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

//save filter search WO

export const saveFilterWO = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .post('/api/filters', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

// get list saved filter search WO

export const savedFilterListWO = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .get('api/filters/get-drop-down-list/4')
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

// get saved filter search WO value

export const getSavedFilterWOValue = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .get(`api/filters/${params.filterId}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

// remove saved filter WO value

export const removeSavedFilterWO = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .patch(`api/filters/inactive/${params.filterId}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

// edit name saved filter Wo value

export const editSavedFilterWO = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .patch('api/filters/update-name', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

//get list contact information

export const getListContactInformation = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .get(`api/prioritized-contacts/get-prioritized-contacts-of-request-for-service/${params.refNo}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

//update or remove contact information
export const editContactInformation = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .patch(`api/request-for-services/${params.refNo}/update-or-remove-prioritized-contact`, params.param)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

//get new contact point information
export const getListContactPointPrioritized = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .get(`api/prioritized-contacts/${params.prioritizedContactId}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const sendEmailWODetail = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .get(`api/reports/pdf/work-orders?Recipients=${params.Recipients}&TimeZoneOffset=${params.TimeZoneOffset}&Refno=${params.Refno}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getLastResolvedWorkOrder = (params) => {
  return Jwt(AppSettings.GLOBAL_API_URL)
    .get(`apiv1/histories/last-resolved-work-orders/${params.WOID}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};
export const resolveCloseDateUpdate = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
  .put(`api/request-for-services/workorder-last-resolvedclosed-udpate-rfs`, params)    
  .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};
export const resolveCloseDateUpdateOnReopenAndNFA = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
  .put(`api/request-for-services/last-resolvedclosed-udpate-null-to-rfs`, params)    
  .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};



// WEBPACK FOOTER //
// ./src/Work-Orders/api.js